export default __webpack_public_path__ + "static/media/rooberttrial-light-webfont.b64617b7.woff2";